import React, { useEffect, useMemo } from "react";
import { useHistory } from "react-router-dom";

import { useMastersContext } from "../../../../contexts/masters.context";
import SetupChargeService from "../../../../services/SetupChargeService";
import CrudTable from "../../shared/table/CrudTable";
import { TABLE_COLUMNS } from "./models/SetupChargesTableColumns";

function SetupChargesTable() {
  const history = useHistory();
  const { setupChargesState } = useMastersContext();

  useEffect(() => {
    setupChargesState.fetch();
  }, []);

  const columns = useMemo(() => TABLE_COLUMNS, [TABLE_COLUMNS]);
  const data = useMemo(() => setupChargesState.data, [setupChargesState.data]);

  const removeSetupCharge = async (id) => {
    if (window.confirm("Are you sure ?") === true) {
      const result = await SetupChargeService.remove(id);
      if (result.success === true) {
        setupChargesState.fetch();
      }
    }
  };

  return (
    <div>
      <div className="row">
        <div className="col"></div>
        <div className="col">
          <h4>Setup Charge</h4>
        </div>
        <div className="col d-flex justify-content-end">
          <button
            className="btn btn-sm btn-success"
            onClick={() => history.push("/masters/setup-charges/add")}
          >
            Add New
          </button>
        </div>
      </div>
      <hr />
      <CrudTable
        loading={setupChargesState.loading}
        data={data || []}
        columns={columns}
        idField="srC_ID"
        onEdit={(id) => history.push(`/masters/setup-charges/edit/${id}`)}
        onRemove={(id) => removeSetupCharge(id)}
      />
    </div>
  );
}

export default SetupChargesTable;
